export function arrayToPlainText(array) {
  const trimmedArray = array.map(item => {
    if (item.endsWith('.')) {
      return item.slice(0, -1);
    }
    return item;
  });
  return trimmedArray.join('. ');
}
